import { wixServerData } from '../utils/wixServerData';
const FALLBACK_LOCALE = 'en';

// Plain fetch: an unauthenticated GET of a public static asset, from a loader
// that runs outside React (no access to the app's httpClient).
const fetchLocale = async (baseUrl, locale) => {
  const response = await fetch(`${baseUrl}/assets/locale/messages_${locale}.json`);
  if (!response.ok) {
    throw new Error(`Failed to fetch translations for locale "${locale}": HTTP ${response.status}`);
  }
  return response.json();
};

// Production injects translationsBaseUrl; Storybook/tests have no renderer and
// use a dedicated bundled extension instead (see @wix/package-picker-sdk).
const fetchTranslations = async locale => {
  const {
    translationsBaseUrl
  } = wixServerData.get();
  if (!translationsBaseUrl) {
    return {};
  }
  try {
    return await fetchLocale(translationsBaseUrl, locale);
  } catch {
    // Degrade to English for a missing/unknown locale or transient CDN error.
    if (locale === FALLBACK_LOCALE) {
      return {};
    }
    return fetchLocale(translationsBaseUrl, FALLBACK_LOCALE).catch(() => ({}));
  }
};

// Several module providers load the same namespace per page; memoize per locale
// to keep it a single request.
const cache = new Map();
export const loadPackagePickerTranslations = locale => {
  const cached = cache.get(locale);
  if (cached) {
    return cached;
  }
  const promise = fetchTranslations(locale);
  cache.set(locale, promise);
  return promise;
};
//# sourceMappingURL=loadTranslations.js.map